import { useEffect, useState } from 'react';
import { Badge } from '@/components/base/badges/badges';
import { Clock } from '@untitledui/icons';

interface ContainerRealtimeIndicatorProps {
    lastUpdateTime: Date;
    className?: string;
}

export const ContainerRealtimeIndicator = ({ lastUpdateTime, className }: ContainerRealtimeIndicatorProps) => {
    const [timeAgo, setTimeAgo] = useState<string>('');

    useEffect(() => {
        const updateTimeAgo = () => {
            const now = new Date();
            const diff = Math.floor((now.getTime() - lastUpdateTime.getTime()) / 1000);
            
            if (diff < 10) {
                setTimeAgo('appena ora');
            } else if (diff < 60) {
                setTimeAgo(`${diff} secondi fa`);
            } else if (diff < 3600) {
                const minutes = Math.floor(diff / 60);
                setTimeAgo(`${minutes} ${minutes === 1 ? 'minuto' : 'minuti'} fa`);
            } else {
                const hours = Math.floor(diff / 3600);
                setTimeAgo(`${hours} ${hours === 1 ? 'ora' : 'ore'} fa`);
            }
        };

        updateTimeAgo();
        const interval = setInterval(updateTimeAgo, 1000);

        return () => clearInterval(interval);
    }, [lastUpdateTime]);

    return (
        <Badge color="brand" size="sm" className={className}>
            <Clock className="size-3 mr-1" />
            Aggiornato {timeAgo}
        </Badge>
    );
};

